import { ScheduledMaintenanceData } from "../models/schedule";

const CHECKUP_TYPE_MESSAGE_IDS: Record<string, string> = {
  BREAK_IN: "intl-msg:periodicReviews.settling",
  Assentamento: "intl-msg:periodicReviews.settling",
  INTERMEDIATE: "intl-msg:periodicReviews.intermediate",
  Intermediária: "intl-msg:periodicReviews.intermediate",
  Intermediaria: "intl-msg:periodicReviews.intermediate",
  L: "intl-msg:periodicReviews.lubrication",
  MP1: "intl-msg:periodicReviews.mp1",
  MP2: "intl-msg:periodicReviews.mp2",
};

export const getCheckupTypeMessageId = (checkupType?: string | null): string | undefined => {
  if (!checkupType?.trim()) return undefined;
  return CHECKUP_TYPE_MESSAGE_IDS[checkupType.trim()];
};

export const getSchedulingCheckupDisplayName = (
  scheduling: {
    maintenanceData?: Pick<ScheduledMaintenanceData, "checkupType"> | null;
    checkup?: { name?: string } | null;
  },
  formatMessage: (descriptor: { id: string }) => string
): string => {
  const checkupType = scheduling.maintenanceData?.checkupType;
  const messageId = getCheckupTypeMessageId(checkupType);

  if (messageId) return formatMessage({ id: messageId });
  if (checkupType) return checkupType;
  return scheduling.checkup?.name ?? "";
};
